<template>
  <v-container fluid>
    <v-dialog
        v-model="editDialog"
        max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Детальная информация</span>
          <v-spacer></v-spacer>
          <v-btn @click="close" fab
                 dark
                 small>
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>

        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                    v-model="editedItem.clientName"
                    disabled
                    label="ФИО"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.userName" label="Номер телефона" disabled></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.statusText" label="Статус" disabled></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.createdAt" label="Дата создания" disabled></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.sum" label="Сумма" disabled></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.paymentMethodText" label="Способ оплаты" disabled></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.deliveryTypeText" label="Способ доставки" disabled></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.address" label="Адрес доставки" disabled></v-text-field>
              </v-col>
            </v-row>
            <div v-if="editedItem.products && editedItem.products.length > 0" class="mt-4">
              <h3>Продукты</h3>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">
                      Наименование
                    </th>
                    <th class="text-left">
                      Количество
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in editedItem.products"
                      :key="item.productId"
                  >
                    <td>{{ item.productName }}</td>
                    <td>{{ item.amount }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Панель фильтров -->
    <v-card class="mb-4">
      <v-card-title>
        Заказы
      </v-card-title>
    </v-card>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Фильтры
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-menu
                  ref="fromMenu"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.dateFrom"
                      prepend-icon="mdi-calendar"
                      label="Дата от"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.dateFrom"
                    @input="menu1 = false"
                    :max="filters.dateTo"
                    locale="ru"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4">
              <v-menu
                  ref="toMenu"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.dateTo"
                      prepend-icon="mdi-calendar"
                      label="Дата до"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.dateTo"
                    @input="menu2 = false"
                    :min="filters.dateFrom"
                    locale="ru"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select v-model="filters.status" :items="statuses" item-value="key" item-text="title" label="Статус" outlined dense persistent-hint multiple />
            </v-col>
            <v-col cols="12" class="d-flex justify-start">
              <v-btn color="primary" @click="getData" class="mr-2">Применить</v-btn>
              <v-btn text @click="resetFilters">Сбросить</v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-card class="mt-6">
      <v-data-table
          :headers="headers"
          :items="data"
          :items-per-page="size"
          :server-items-length="totalElements"
          :options.sync="options"
          :multi-sort="false"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': 'Строк на странице:',
            'items-per-page-options': [5, 10, 20, 50]
          }"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="openDialog(item)" fab small color="teal">
            <v-icon color="white">
              mdi-view-list
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.statusText`]="{ item }">
          <v-chip v-if="item.status === 'PROCESS'" color="primary">
            {{ item.statusText }}
          </v-chip>
          <v-chip v-if="item.status === 'DECLINED'" color="red" text-color="white">
            {{ item.statusText }}
          </v-chip>
          <v-chip v-if="item.status === 'SUCCESS'" color="green" text-color="white">
            {{ item.statusText }}
          </v-chip>
          <v-chip v-if="item.status === 'RETURNED'">
            {{ item.statusText }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>


export default {
  name: 'PartnerOrders',
  data() {
    return {
      menu1: false,
      menu2: false,
      statuses: [
        { title: 'Успешный', key: "SUCCESS"},
        { title: 'Отклоненный', key: "DECLINED"},
        { title: 'В процессе', key: "PROCESS"},
        { title: 'Возврат', key: "RETURNED"},
      ],
      filters: {
        status: [],
        dateFrom: "",
        dateTo: "",
      },
      editedItem: {
        clientName: null,
        userName: null,
        createdAt: null,
        sum: null,
        paymentMethodText: null,
        products: [],
      },
      editDialog: false,
      data: [],
      size: 10,
      roles: ['Снабженец', 'Сотрудник'],
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'ФИО', value: 'clientName' },
        { text: 'Номер телефона', value: 'userName' },
        { text: 'Цена', value: 'sum' },
        { text: 'Способ доставки', value: 'deliveryTypeText' },
        { text: 'Способ оплаты', value: 'paymentMethodText' },
        { text: 'Статус', value: 'statusText' },
        { text: 'Действия', value: 'actions' },
      ],
      totalElements: 0,
      options: {},
      jobs: [],
      categories: [],
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  mounted() {
  },
  methods: {
    updatePhone(value) {
      const digits = value.replace(/\D/g, '').slice(0, 11)
      const formatted = this.formatPhone(digits)
      return formatted
    },
    formatPhone(digits) {
      if (!digits) return '+7 '
      const part1 = digits.substring(1, 4)
      const part2 = digits.substring(4, 7)
      const part3 = digits.substring(7, 9)
      const part4 = digits.substring(9, 11)
      return `+7 (${part1}${part1.length === 3 ? ')' : ''}${part2 ? ' ' + part2 : ''}${part3 ? '-' + part3 : ''}${part4 ? '-' + part4 : ''}`
    },
    openDialog (item) {
      this.editedItem = item
      this.editDialog = true
    },
    close () {
      this.editDialog = false
      this.editedItem = {
        clientName: null,
        userName: null,
        createdAt: null,
        sum: null,
        paymentMethodText: null,
        products: [],
      }
    },
    resetFilters() {
      this.filters = {
        status: [],
        dateFrom: "",
        dateTo: "",
      }
      this.getData()
    },
    async getData () {
      try {
        const sortBy = this.options.sortBy && this.options.sortBy.length > 0 ? this.options.sortBy[0] : ''
        const ascOrDesc = sortBy ? this.options.sortDesc.length > 0 ? (this.options.sortDesc[0] ? 'desc' : 'asc') : '' : ''
        const data = {
          size: this.options['itemsPerPage'],
          page: this.options['page'] - 1,
          dateFrom: this.filters.dateFrom,
          dateTo: this.filters.dateTo,
          status: this.filters.status,
        }
        if (sortBy) {
          data.orderBy = sortBy
          data.ascOrDesc = ascOrDesc
        }
        const resp = await this.$store.dispatch('partnerOrders/getPartnerOrders', data)
        this.data = resp.list.map((item) => {
          item.deliveryTypeText = item.deliveryType === 'DELIVERY' ? 'Доставка' : 'Самовывоз'
          item.statusText = item.status === 'DECLINED' ? 'Отклонено' : 'В процессе'
          item.paymentMethodText = item.paymentMethod === 'CASH' ? 'Наличные' : 'Картой'
          item.userName = this.updatePhone(item.userName)
          return item
        })
        this.totalElements = resp.totalElements
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>
<style scoped>

</style>